import type { Limrun } from "@limrun/api";

export const IOS_MODEL_LABEL = "limrun.com/console-ios-model";

export type IOSModel = NonNullable<
  NonNullable<Limrun.IosInstanceCreateParams["spec"]>["model"]
>;

// The display name of every model the console offers; its keys are the models it accepts.
export const IOS_MODEL_NAMES: Record<IOSModel, string> = {
  iphone: "iPhone",
  "iphone-duo": "iPhone Duo",
  ipad: "iPad (alpha)",
  watch: "Apple Watch (alpha)",
};

const IOS_MODELS = Object.keys(IOS_MODEL_NAMES) as IOSModel[];

export function parseIOSModel(value: string | null | undefined): IOSModel | undefined {
  if (!value) return undefined;

  const normalized = value.toLowerCase();
  return IOS_MODELS.includes(normalized as IOSModel) ? normalized as IOSModel : undefined;
}

export function getLabeledIOSModel(labels: Record<string, string> | undefined): IOSModel | undefined {
  return parseIOSModel(labels?.[IOS_MODEL_LABEL]);
}

export function isInternalInstanceLabel(key: string): boolean {
  return key === IOS_MODEL_LABEL;
}
